import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class DateCreatedColumn extends Column {
    title = 'employees.records.dateCreated';
    property = 'createdAt';
    type: CellDisplay = CellDisplay.date;
    sortable = true;
}
